import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
// import svg
import AWSLogo from '../images/skills/aws.svg'
import AzureLogo from '../images/skills/azure.svg'
import CSharpLogo from '../images/skills/c-sharp.svg';
import CypressLogo from '../images/skills/cypress.svg';
import GithubLogo from '../images/skills/github.svg';
import JsLogo from '../images/skills/javascript.svg';
import MaterialUILogo from '../images/skills/material-ui.svg';
import NodeLogo from '../images/skills/node.svg';
import ReactLogo from '../images/skills/react.svg';
import ReduxLogo from '../images/skills/redux.svg';
import TsLogo from '../images/skills/typescript.svg';
import VitestLogo from '../images/skills/vitest.svg';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';

const logos = [
    {
        source: AWSLogo,
        title: 'AWS EC2',
    },
    {
        source: AzureLogo,
        title: 'Azure Functions',
    },
    {
        source: CSharpLogo,
        title: 'C#',
    },
    {
        source: JsLogo,
        title: 'JavaScript',
    },
    {
        source: TsLogo,
        title: 'TypeScript',
    },
    {
        source: NodeLogo,
        title: 'Node Express',
    },
    {
        source: ReactLogo,
        title: 'React',
    },
    {
        source: ReduxLogo,
        title: 'Redux Toolkit',
    },
    {
        source: GithubLogo,
        title: 'Github Pages & Actions',
    },
    {
        source: MaterialUILogo,
        title: 'Material UI',
    },
    {
        source: VitestLogo,
        title: 'Vitest',
    },
    {
        source: CypressLogo,
        title: 'Cypress E2E',
    },
]

const logoStyles = {
    width: '80px',
    height: '80px',
    margin: '1px 32px',
    opacity: 0.8,
};
const scrollToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
    }
  };

export const Skill: React.FC = () => {
    return(
        <Box id='skills' sx={{py: 8}}>
            <Typography
              component='p'
              variant='h4'
              align='center'
              color='text.main'
            >
                SKILLS
            </Typography>
            <Typography
              component='p'
              variant='subtitle1'
              align='center'
              color='text.secondary'
            >
                Experience with these technologies
            </Typography>
            <Grid container justifyContent="center" sx={{ mt: 2, mb: 8, opacity: 0.8 }}>
                {logos.map((logo, index)=>(
                    <Grid item key={index}>
                        <Tooltip title={logo.title}>
                        <img
                          src={logo.source}
                          alt={logo.title}
                          style={logoStyles}
                        />
                        </Tooltip>
                    </Grid>
                ))}
            </Grid>
            <Divider variant='middle' style={{width:'80%', margin:'auto'}}>
            <IconButton onClick={()=> scrollToSection('introduction')} style={{alignSelf:'center', background:'transparent'}}>
                <ArrowCircleUpIcon sx={{color: 'grey', fontSize:40, '&&:hover':{background:'none', color:'primary.main'} }}/>
            </IconButton>
            </Divider>
        </Box>
    )
} 